// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"703":"8fc593f85a2cff076f8f","886":"7b568a8eb89900f67695","954":"616c5ef6a494c897379f"}[chunkId] + ".css";
};